import React from "react";
import { Alert, Table } from "antd";
import TableColumnWithTooltip from "../../shared/TableColumnWithTooltip/TableColumnWithTooltip";
import { semTableColumns } from "../../shared/TableColumnWithTooltip/semTableColumns";
import KeywordPosition from "../../shared/KeywordPosition";

const { Column } = Table;

function TopKeywordsReport({ keywords }) {
  const tableDataSource = keywords.map((keyword, idx) => ({
    key: idx + 1,
    keyword: keyword.phrase,

    position: keyword["pos"] ? parseInt(keyword["pos"]) : null,
    previousPosition: keyword["prev_pos"] ? parseInt(keyword["prev_pos"]) : 0,
    traffic: keyword["traffic"] ? parseFloat(keyword["traffic"]).toLocaleString() : "-"
  }));

  return (
    <React.Fragment>
      {keywords.length ? (
        <div className="keywords-table">
          <Table dataSource={tableDataSource} pagination={false} size="small">
            <Column title="#" dataIndex="key" align="right" />
            <Column className="no-wrap" title="Keyword" dataIndex="keyword" />
            <Column
              title={<TableColumnWithTooltip {...semTableColumns["position"]} />}
              dataIndex="position"
              render={(_, record) => <KeywordPosition {...record} />}
            />
            <Column
              className="al-right"
              title={<TableColumnWithTooltip {...semTableColumns["traffic"]} />}
              dataIndex="traffic"
            />
          </Table>
        </div>
      ) : (
        <Alert message="Your domain has no indexed keywords!" />
      )}
    </React.Fragment>
  );
}

export default TopKeywordsReport;
